<kendo-dialog-titlebar>
    {{'admin-center.header.addNewEmployee' | translate}}
</kendo-dialog-titlebar>

<form [formGroup]="addDataForm">

    <app-employee-form [form]="addDataForm"></app-employee-form>

</form>

<kendo-dialog-actions>
    <button  type="button" kendoButton (click)="confirm()" [primary]="true" submit>
        <span>{{'global.add' | translate}}</span>
    </button>
</kendo-dialog-actions>